export const pdiLeadCreated = {
    event: "pdi_lead_created",
    eventCategory: "ppi_book_flow",
    eventAction: "lead_created"
};

export const pdiViewAllBrand = {
    event: "pdi_view_all_brands",
    eventCategory: "ppi_homepage",
    eventAction: "view_all_brands"
};

export const pdiBrandClicked = {
    event: "pdi_brand_clicked",
    eventCategory: "ppi_homepage",
    eventAction: "brand_selected"
};

export const pdiRegNumberEntered = {
    event: "pdi_reg_number_entered",
    eventCategory: "ppi_homepage",
    eventAction: "reg_number_entered"
};

export const pdiCancelled = {
    event: "pdi_cancelled",
    eventCategory: "ppi_book_flow",
    eventAction: "appointment_cancelled"
};

export const confirmLocation = {
    event: "confirm_location",
    eventAction: "confirm_location",
    eventCategory: "ppi_book_flow"
};

export const bookInspectionClick = {
    event: "book_inspection_clicked",
    eventAction: "book_inspection_clicked",
    eventCategory: "ppi_book_flow"
};

export const pdiAppointmentReschedule = {
    event: "appointment_rescheduled",
    eventAction: "appointment_rescheduled",
    eventCategory: "ppi_post_book_flow"
};

export const pdiDownloadReport = {
    event: "download_report",
    eventAction: "download_report",
    eventCategory: "ppi_post_book_flow"
};

export const pdiCjCallClick = {
    event: "call_cj_click",
    eventAction: "call_cj_click",
    eventCategory: "ppi_post_book_flow"
};

export const carDetailEdit = {
    event: "car_detail_edit_click",
    eventCategory: "ppi_book_flow",
    eventAction: "car_detail_edit_click"
};

export const carDetailConfirm = {
    event: "car_detail_confirmed",
    eventCategory: "ppi_book_flow",
    eventAction: "car_detail_confirmed"
};

export const userCategorySelect = {
    event: "user_category_selected",
    eventCategory: "ppi_book_flow",
    eventAction: "user_category_selected"
};

export const pdiUserIntent = {
    event: "used_car_selected",
    eventAction: "used_car_selected",
    eventCategory: "ppi_book_flow"
};

export const pdiManualFlowModel = {
    event: "model_selected",
    eventCategory: "ppi_book_flow",
    eventAction: "model_selected"
};

export const pdiVideoWatch = {
    event: "video_watch_time",
    eventCategory: "ppi_homepage",
    eventAction: "video_watch_time"
};

export const pdiVideoStart = {
    event: "video_started",
    eventCategory: "ppi_homepage",
    eventAction: "video_started"
};

export const pdiHomeBookInspection = {
    event: "home_cta_clicked",
    eventCategory: "ppi_homepage",
    eventAction: "home_cta_clicked"
};

export const pdiFaqClick = {
    event: "faq_clicked",
    eventCategory: "ppi_homepage",
    eventAction: "faq_clicked"
};

export const pdiBenefitsSlideChanged = {
    event: "booking_detail_scroll",
    eventCategory: "ppi_homepage",
    eventAction: "booking_step_scroll"
};

export const pdiTestimonialSlideChanged = {
    event: "testimonial_scroll",
    eventCategory: "ppi_homepage",
    eventAction: "testimonial_scroll"
};

export const pdiReadMoreClicked = {
    event: "seo_read_more",
    eventCategory: "ppi_homepage",
    eventAction: "seo_read_more"
};

export const pdiWhatIsInspection = {
    event: "seo_content_click",
    eventCategory: "ppi_homepage",
    eventAction: "seo_content_click"
};

export const pdiQualityCheckClicked = {
    event: "benefits_read",
    eventCategory: "ppi_homepage",
    eventAction: "benefits_read_click"
};

export const pdiChooseCarType = {
    event: "car_type_cta",
    eventCategory: "ppi_homepage",
    eventAction: "car_type_cta"
};
